export const downloadFileByUrl = (url: string, filename = '') => {
  let src = url;
  const link = document.createElement('a');
  link.href = src;
  link.download = filename;
  if (src.indexOf('?') === -1) {
    src += '?download';
  }
  link.click();
  link.remove();
};

export const downloadFileByBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export function downloadFile(url: string, filename: string) {
  fetch(url)
    .then((response) => response.blob())
    .then((result) => {
      downloadFileByBlob(result, filename);
    });
}
